"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  name: 'CardDashboardMonitor',
  props: {
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    milliseconds: {
      type: [String, Number],
      default: 0
    },
    request: {
      type: [String, Number],
      default: 0
    },
    logo: {
      type: String,
      default: ''
    },
    total: {
      type: [String, Number],
      default: 0
    },
    lastUpdate: {
      type: String,
      default: ''
    },
    totalSuccess: {
      type: [String, Number],
      default: 0
    },
    totalError: {
      type: [String, Number],
      default: 0
    },
    load: {
      type: Boolean,
      default: false
    }
  }
};
exports.default = _default;